import React from "react";
import { cn } from "@/lib/utils";
import { usdCompact, usdExact } from "@/lib/format";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

// Compact KPI currency with an accessible exact-value tooltip (hover + focus + tap).
// Raw numeric value is never mutated; exact value stays available for copy/export upstream.
export function KpiValue({ value, currency = "USD", label, className, testid }) {
  const compact = usdCompact(value, currency);
  const exact = usdExact(value, currency);
  const accessible = label ? `${label}: ${exact}` : `Exact value: ${exact}`;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid={testid}
            tabIndex={0}
            aria-label={accessible}
            title={exact}
            className={cn("metric-value inline-block max-w-full whitespace-nowrap tabnum align-baseline focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/50 rounded-sm", className)}
          >
            {compact}
          </span>
        </TooltipTrigger>
        <TooltipContent>Exact value: {exact}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
